<template>
  <div>
    <vue-headful title="Credimóvil | Solicita tu crédito"/>
    <menu-component></menu-component>


    <!-- Banner Area -->
    <section class="banner_area banner_area_3">
    	<div class="container">
    		<h6>Pre aprobado en 2 minutos</h6>
    		<h2>
          <a href="/pre-approval" class="title-redirect">Solicita un crédito</a>
        </h2>
    		<ol class="breadcrumb">
                <li></li>
                <li></li>
            </ol>
    	</div>
    </section>
    <!-- Banner Area -->

    <!-- Services Details Area -->
    <section class="services_details ofrece-credito">
        <div class="container">
            <div class="features_b">
                <h3>Beneficios</h3>
                <p>Credimóvil es un servicio 100% online y seguro para ofrecerte el financiamiento de tu auto sin necesidad
                    de historial crediticio, ni comprobación de ingresos, puedes iniciar tu proceso desde la comodidad de tu hogar.</p>
            </div>
            <div class="row">
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-velocidad"></i>
                    <h4>Rapidez</h4>
                </div>
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-bloqueado"></i>
                    <h4>Seguro</h4>
                </div>
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-innovacion"></i>
                    <h4>Innovación</h4>
                </div>
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-lealtad"></i>
                    <h4>Compromiso</h4>
                </div>
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-proteger"></i>
                    <h4>Confianza</h4>
                </div>
                <div class="col-xl col-lg-2 col-md-4 col-sm-6 loan">
                    <i class="flaticon-mano"></i>
                    <h4>Simplicidad</h4>
                </div>
            </div>
        </div>
    </section>
    <!-- Services Details Area -->

    <!-- Eligibility Criteria Area -->
    <div class="container">
      <div class="holidaying of-credit">
        <h3>¿Por qué Credimóvil?</h3>
        <div class="col-12">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <ul>
                <li>Garantizamos la seguridad de tus datos</li>
                <li>Preaprobación inmediata</li>
                <li>Aprobación en menos de 48 horas</li>
                <li>Desde 20% de enganche</li>
                <li>Rápido y fácil</li>
                <li>Totalmente en línea</li>
                <li>Distintas opciones para tus necesidades</li>
                <li>Te acompañamos en todo el proceso</li>
              </ul>
            </div>
            <div class="col-md-6 col-sm-12">
              <ul>
                <li>Plazos de hasta 48 meses</li>
                <li>Vehículos de hasta 12 años de antigüedad</li>
                <li>Flexibilidad en buro</li>
                <li>Cobertura nacional</li>
                <li>Sin comprobar ingresos</li>
                <li>Sin necesidad de historial crediticio</li>
                <li>Asesoría sin costo</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Eligibility Criteria Area -->

    <!-- How It Work Area -->
    <section class="how_it_work">
        <div class="container">
            <div class="tittle">
                <h2>Aplica en 3 sencillos pasos, <span>proceso de solicitud rápido y fácil</span></h2>
            </div>
            <div class="media step_m">
                <div class="media-left">
                    <img src="images/icons/b-step-1.png" alt="">
                </div>
                <div class="media-body">
                    <h3>Paso 1</h3>
                    <h6>Llena tu solicitud completamente en línea. Se consulta automaticamente el buró y pre aprobamos tu crédito en cuestión de minutos.</h6>
                    <a class="theme_btn" href="/pre-approval">Aplicar ahora</a>
                </div>
            </div>
            <div class="media step_m sm_2">
                <div class="media-left">
                    <img src="images/icons/b-step-2.png" alt="">
                </div>
                <div class="media-body">
                    <h3>Paso 2</h3>
                    <h6>Basado en el resultado, solicitamos que ingreses tus documentos en nuestra plataforma.</h6>
                </div>
            </div>
            <div class="media step_m sm_3">
                <div class="media-left">
                    <img src="images/icons/aprobacion.png" alt="">
                </div>
                <div class="media-body">
                    <h3>Paso 3</h3>
                    <h6>Se te notificará la aprobación de tu crédito y un asesor especializado se contactará contigo.</h6>
                </div>
            </div>
        </div>
    </section>
    <!-- How It Work Area -->

    <!-- Required documents -->
    <section class="required_documents">
        <div class="container">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Documentos requeridos</th>
                            <th scope="col">Persona física</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Identificación oficial y vigente</td>
                            <td><i class="fa fa-check-circle"></i></td>
                        </tr>
                        <tr>
                            <td>Comprobante domicilio no mayor a 3 meses. (Agua, luz o teléfono)</td>
                            <td><i class="fa fa-check-circle"></i></td>
                        </tr>
                        <tr>
                            <td>Últimos 3 meses de comprobantes de ingresos. (Nóminas o estados de cuenta bancarios)</td>
                            <td><i class="fa fa-check-circle"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
    <div class="container">
        <div class="get_loan_area">
            <p>Te asesoramos en la obtención de tu crédito, sin costo y sin compromiso, sin necesidad de historial crediticio y con
                flexibilidad en buro. <br>
                <!-- Manejamos tasas promocionales de hasta 2.32% mensual.  -->
                </p>
            <a href="/pre-approval" class="theme_btn">Aplicar ahora</a>
        </div>
    </div>
    <!-- End Required documents -->
  </div>
</template>

<script>
  export default {
    name: 'CreditRequest'
  }
</script>

<style lang="scss">
  .title-redirect {
    color: white;
    text-decoration: none;
  }
  .title-redirect:hover {
    color: #eee;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/CreditRequest.vue